import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Icon, PulsingOrb, Text } from '~/atomic';
import { useAppSelector } from '~/store';
import { selectLogin } from '~/store/auth/login/selectors';

export default function Splashscreen() {
  const navigate = useNavigate();
  const { signed } = useAppSelector(selectLogin);

  useEffect(() => {
    const t = setTimeout(() => {
      navigate(signed ? '/app/home' : '/auth/login', { replace: true });
    }, 1000);
    return () => clearTimeout(t);
  }, [signed, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-primary-01 gap-medium">
      <PulsingOrb color="#FFFFFF" size={140} />
      <div className="flex items-center gap-nano">
        <Icon name="icon-security" size={28} color="#FFFFFF" rounded={false} />
        <Text className="text-display1 color-intense-01">Paga Agro</Text>
      </div>
      <Text className="text-bodyMD color-intense-01/80">
        Gerencie seus financiamentos rurais
      </Text>
    </div>
  );
}
